<template>
	<!-- tabbar 分类 -->
	<div class="categroyBox">
		<!-- 分站 -->
		<div class="fenzhan">
			<h4>分站</h4>
			<div class="jinpinBox">
				<div class="jinpin_left" v-for="(item,idx) in zhan_list" @click="jumpUrlPage(idx)">
					<div class="jp_bookName">
						<div class="jp_bookImg">
							<img :src="$api.$BASE_URL_img + item.cover_image" alt="">
						</div>
						<div>
							<p>{{item.category_name}}</p>
							<p v-if="idx == 0">歌颂男女之间的纯真爱恋</p>
							<p v-if="idx == 1">讲述超越性别的感情故事</p>
							<p v-if="idx == 2">比原著更萌的cp配对</p>
							<p v-if="idx == 3">剧情大触聚集地</p>
						</div>
					</div>
				</div>
			</div>
		</div>
		<!-- 分频 -->
		<div class="fenzhan">
			<h4>分频</h4>
			<div class="jinpinBox">
				<div class="jinpin_left" v-for="(item,idx) in pin_list" @click="jumpPinFn(idx)">
					<div class="jp_bookName">
						<div class="jp_bookImg">
							<img :src="$api.$BASE_URL_img + item.cover_image" alt="">
						</div>
						<div>
							<p>{{item.category_name}}</p>
							<p v-if="idx == 0">萌萌cp</p>
							<p v-if="idx == 1">纯纯cp</p>
							<p v-if="idx == 2">古代背景的纯纯感情</p>
							<p v-if="idx == 3">现代都市的甜蜜互动</p>
							<p v-if="idx == 4">古代背景的感情故事</p>
							<p v-if="idx == 5">现代都市的爱情传说</p>
							<p v-if="idx == 6">大开脑洞的虚构幻想</p>
							<p v-if="idx == 7">奇思妙想与天马行空</p>
							<p v-if="idx == 8">女生之间的化学反应</p>
							<p v-if="idx == 9">剧情大触聚集地</p>
						</div>
					</div>
				</div>
			</div>
		</div>

	</div>
	</div>
</template>

<script>
	export default{
		data(){
			return{
				pin_list:[],//分频
				zhan_list:[],//分站
			}
		},
		created() {
			this.categoryList()
		},
		methods:{
			categoryList(){
				this.$axios.post(this.$api.categoryList).then(res => {
					this.pin_list= res.data.data.pin_list;
					this.zhan_list = res.data.data.zhan_list;
					
				})
			},
			jumpUrlPage(idx){
				if(idx == 0){
					this.$router.push({path:'/yanqing',query:{categoryIdx: 'yq0'}})
				}else if(idx == 1){
					this.$router.push({path:'/chunai',query:{categoryIdx: 'ca0'}})
				}else if(idx == 2){
					this.$router.push({path:'/yansheng',query:{categoryIdx: 'ys0'}})
				}else if(idx == 3){
					this.$router.push({path:'/cp',query:{categoryIdx: 'cp0'}})
				}
			},
			jumpPinFn(idx){
				if(idx == 0){
					this.$router.push({path:'/yansheng_yq',query:{categoryIdx: 'yq0'}})
				}else if(idx == 1){
					this.$router.push({path:'/yansheng_ca',query:{categoryIdx: 'ca0'}})
				}else if(idx == 2){
					this.$router.push({path:'/chunai_gdca',query:{categoryIdx: 'ca0'}})
				}else if(idx == 3){
					this.$router.push({path:'/chunai_xdca',query:{categoryIdx: 'ca0'}})
				}else if(idx == 4){
					this.$router.push({path:'/gdyq',query:{categoryIdx: 'ca0'}})
				}else if(idx == 5){
					this.$router.push({path:'/xdyq',query:{categoryIdx: 'ca0'}})
				}else if(idx == 6){
					this.$router.push({path:'/hxyq',query:{categoryIdx: 'ca0'}})
				}else if(idx == 7){
					this.$router.push({path:'/chunai_hxca',query:{categoryIdx: 'ca0'}})
				}else if(idx == 8){
					this.$router.push({path:'/chunai_bh',query:{categoryIdx: 'ca0'}})
				}else if(idx == 9){
					this.$router.push({path:'/cp',query:{categoryIdx: 'ca0'}})
				}
			}
		}
	}
</script>

<style scoped lang="less">
	.categroyBox{
		padding-top: 60px;
		background-color: #fff;
		overflow-y: scroll;
		height: calc(100vh - 220px);
	}
	/* 精品 */
	.fenzhan {
		background-color: #fff;
		padding: 0 16px;
		// margin-bottom: 10px;
		h4 {
			flex: 1;
			font-size: 30px;
			/*px*/
			color: #ff4081;
			padding: 20px 0;
			font-weight: 700;
		}

		.jinpinBox {
			margin-top: 10px;
			overflow: hidden;

			.jinpin_left {
				width: calc(50% - 14px);
				background-color: #fff;
				float: left;
				padding-right: 5px;
				padding-bottom: 16px;
				overflow: hidden;

				.jp_bookName {
					display: flex;
					height: 240px;
					position: relative;
					margin: 0 auto;
					.jp_bookImg {
						position: absolute;
						top: 50%;
						left: 0;
						-webkit-transform: translateY(-50%);
						-moz-transform:translateY(-50%);
						-ms-transform: translateY(-50%);
						-o-transform:translateY(-50%);
						transform: translateY(-50%);
						width: 50%;
						img {
							width: 155px;
							height: 220px;/*px*/
							-webkit-box-shadow: 0 3px 3px 0 rgba(0, 0, 0, .3);
							/*no*/
							-moz-box-shadow:  0 3px 3px 0 rgba(0, 0, 0, .3);
							/*no*/
							box-shadow:  0 3px 3px 0 rgba(0, 0, 0, .3);
							/*no*/
						}
					}

					>div:last-child {
						position: absolute;
						top: 50%;
						right: 0;
						transform: translateY(-50%);
						text-align: left;
						width: 50%;

						p:first-child {
							font-size: 30px;
							/*px*/
							padding-bottom: 10px;
							color: #000;
						}

						p:last-child {
							overflow: hidden;
							// white-space: nowrap;
							// text-overflow: ellipsis;
							font-size: 24px;
							/*px*/
							color: #000;
							opacity: 0.4;
							height: 80px;
							line-height: 40px;
						}
					}
				}
			}

			.jinpin_left:nth-child(2n) {
				padding-right: 0px;
				padding-left: 5px;
			}
		}
	}
</style>
